import decadentDessert from '../img/DecadentDessert2025.png';



import applePie from '../cjs-imgs/ApplePie.svg';
import applePieBlonde from '../cjs-imgs/ApplePieBlonde.svg';
import bananaMuffin from '../cjs-imgs/BananaMuffin.svg';
import bananaScoop from '../cjs-imgs/BananaScoop.svg';
import blackForestSlice from '../cjs-imgs/BlackForestSlice.svg';
import blueberryCheeseCake from '../cjs-imgs/BlueberryCheeseCake.svg';
import chocolateBrownie from '../cjs-imgs/ChocolateBrownie.svg';
import chocolateChipMuffin from '../cjs-imgs/ChocolateChipMuffin.svg';
import chocolateFudgeSlice from '../cjs-imgs/ChocolateFudgeSlice.svg';
import chocolateMuffin from '../cjs-imgs/ChocolateMuffin.svg';
import chocolateScoop from '../cjs-imgs/ChocolateScoop.svg';
import coconutScoop from '../cjs-imgs/CoconutScoop.svg';
import coffeeScoop from '../cjs-imgs/CoffeeScoop.svg';
import creamyCarrotSlice from '../cjs-imgs/CreamyCarrotSlice.svg';
import lemonCakeSlice from '../cjs-imgs/LemonCakeSlice.svg';
import BananaCakeSlice from '../cjs-imgs/BananaCakeSlice.svg';

import mangoScoop from '../cjs-imgs/MangoScoop.svg';
import marbleCakeSlice from '../cjs-imgs/MarbleCakeSlice.svg';
import mintScoop from '../cjs-imgs/MintScoop.svg';
import oreoCheeseCake from '../cjs-imgs/OreoCheeseCake.svg';
import passionCheeseCake from '../cjs-imgs/PassionCheeseCake.svg';
import redVelvetSlice from '../cjs-imgs/RedVelvetSlice.svg';
import sliceALaMode from '../cjs-imgs/SliceALaMode.svg';
import strawberryScoop from '../cjs-imgs/StrawberryScoop.svg';
import tripleChocolateSquae from '../cjs-imgs/TripleChocolate.svg';

import vanillaMuffin from '../cjs-imgs/VanillaMuffin.svg';
import vanillaScoop from '../cjs-imgs/VanillaScoop.svg';
import whiteForest from '../cjs-imgs/WhiteForest.svg';

import plainCroissand from '../cjs-imgs/PlainCroissant.svg';
import almondCroissant from '../cjs-imgs/AlmondCroissant.svg';
import chocolateTwist from '../cjs-imgs/ChocolateTwist.svg';
import CinnamonCroissant from '../cjs-imgs/CinnamonCroissant.svg';

import FruitSalad from '../cjs-imgs/FruitSalad.svg';
import HotFudgeSundae from '../cjs-imgs/HotFudgeSundae.svg';
import ChocolateBrownieSundae from '../cjs-imgs/ChocolateBrownieSundae.svg';
import IceCreamCookieSandwich from '../cjs-imgs/IceCreamCookieSandwich.svg';
import IceCreamSundae from '../cjs-imgs/IceCreamSundae.svg';
import BananaSplitSundae from '../cjs-imgs/BananaSplitSundae.svg';
import FudgeObsession  from '../cjs-imgs/FudgeObsession.svg';
import Brownieindulgence  from '../cjs-imgs/Brownieindulgence.svg';


import tripleChocolateRect from '../img/DecadentDessert/tripleChocolateRect.png';
import passionCheeseCakeRect from '../img/DecadentDessert/passionCheeseCakeRect.png';
import oreoCheeseCakeRect from '../img/DecadentDessert/oreoCheeseCakeRect.png';
import blueberryCheeseCakeRect from '../img/DecadentDessert/blueberryCheeseCakeRect.png';

import bananaMuffinRect from '../img/DecadentDessert/bananaMuffinRect.png';
import chocolateChipMuffinRect from '../img/DecadentDessert/chocolateChipMuffinRect.png';
import vanillaMuffinRect from '../img/DecadentDessert/vanillaMuffinRect.png';
import chocolateMuffinrect from '../img/DecadentDessert/chocolateMuffinrect.png';

import plainCroissandRect from '../img/DecadentDessert/plainCroissandReact.png';
import almondCroissantRect from '../img/DecadentDessert/almondCroissantRect.png';
import chocolateTwistRect from '../img/DecadentDessert/chocolateTwistRect.png';
import CinnamonCroissantRect from '../img/DecadentDessert/CinnamonCroissantRect.png';

import HotFudgeSundaeRect from '../img/DecadentDessert/HotFudgeSundaeRect.png';

import FruitSaladRect from '../img/DecadentDessert/FruitSaladRect.png';
import ChocolateBrownieSundaeReact from '../img/DecadentDessert/ChocolateBrownieSundaeReact.png';
import IceCreamCookieSandwichRect from '../img/DecadentDessert/IceCreamCookieSandwichRect.png';
import IceCreamSundaeRect from '../img/DecadentDessert/IceCreamSundaeRect.png';
import BananaSplitSundaeRect from '../img/DecadentDessert/BananaSplitSundaeRect.png';


import FudgeObsessionRect from '../img/DecadentDessert/FudgeObsessionRect.png';
import BrownieindulgenceRect from '../img/DecadentDessert/BrownieindulgenceRect.png';
import applePieBlondeRect from '../img/DecadentDessert/applePieBlondeRect.png';
import sliceALaModeRect from '../img/DecadentDessert/sliceALaModeRect.png';

import vanillaScoopRect from '../img/DecadentDessert/vanillaScoopRect.png';
import strawberryScoopRect from '../img/DecadentDessert/strawberryScoopRect.png';
import chocolateScoopRect from '../img/DecadentDessert/chocolateScoopRect.png';
import bananaScoopRect from '../img/DecadentDessert/bananaScoopRect.png';
import mintScoopRect from '../img/DecadentDessert/mintScoopRect.png';
import mangoScoopRect from '../img/DecadentDessert/mangoScoopRect.png';
import coffeeScoopRect from '../img/DecadentDessert/coffeeScoopRect.png';
import coconutScoopRect from '../img/DecadentDessert/coconutScoopRect.png';
import doubleScoop from '../img/DecadentDessert/doubleScoop.png';
import doubleScoopRect from '../img/DecadentDessert/doubleScoopRect.png';

import blackForestSliceRect from '../img/DecadentDessert/blackForestSliceRect.png';
import applePieRect from '../img/DecadentDessert/applePieRect.png';
import chocolateFudgeSliceRect from '../img/DecadentDessert/chocolateFudgeSliceRect.png';
import redVelvetSliceRect from '../img/DecadentDessert/redVelvetSliceRect.png';
import creamyCarrotSliceRect from '../img/DecadentDessert/creamyCarrotSliceRect.png';
import whiteForestRect from '../img/DecadentDessert/whiteForestRect.png';
import marbleCakeSliceRect from '../img/DecadentDessert/marbleCakeSliceRect.png';
import lemonCakeSliceRect from '../img/DecadentDessert/lemonCakeSliceRect.png';
import BananaCakeSliceRect from '../img/DecadentDessert/BananaCakeSliceRect.png';
import chocolateBrownieRect from '../img/DecadentDessert/chocolateBrownieRect.png';
import gingerCookiesRect from '../img/DecadentDessert/gingerCookiesRect.png';
import TiramisuCheese from '../img/DecadentDessert/TiramisuCheese.png';
import SaltedCaramel from '../img/DecadentDessert/SaltedCaramelCake.png';
import SaltedCaramelRect from '../img/DecadentDessert/SaltedCaramelCakeRect.png';



const DecadentDessert =    {
    "ImageURL": decadentDessert,
    "Name":"Decadent Dessert",
    "OpenTime":"06:00 AM - 11:00 PM",
    "Status":"Opened",
    "type":[
        {
            "ImageURL": tripleChocolateSquae,
            "Name": "Triple Chocolate",
            "category": "Cheese Cakes",
            "dec": "Triple chocolate mousse with layers of dark chocolate, white chocolate & milk chocolate over an espresso chocolate cake base.",
            "KES": 530,
            "RectImageURL":tripleChocolateRect,
            "Upgrades":[
            ]

        },
        {
            "ImageURL": passionCheeseCake,
            "Name": "Passion Cheese Cake",
            "category": "Cheese Cakes",
            "dec": "Passion Cheese Cake",
            "KES": 530,
            "RectImageURL":passionCheeseCakeRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": oreoCheeseCake,
            "Name": "Oreo Cheese Cake",
            "category": "Cheese Cakes",
            "dec": "Oreo Cheese Cake",
            "KES": 530,
            "RectImageURL":oreoCheeseCakeRect,

            "Upgrades":[
            ]
        },
        {
            "ImageURL": blueberryCheeseCake,
            "Name": "Blueberry Cheese Cake",
            "category": "Cheese Cakes",
            "dec": "Blueberry Cheese Cake",
            "KES": 530,
            "RectImageURL":blueberryCheeseCakeRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": TiramisuCheese,
            "Name": "Tiramisu Cheese Cake",
            "category": "Cheese Cakes",
            "dec": "A creamy dessert of ladyfinger cookies dipped in an espresso, layered with delicately sweetened whipped eggs and mascarpone cheese, and topped with a dusting of cocoa powder .",
            "KES": 530,
            "RectImageURL":TiramisuCheese,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": bananaMuffin,
            "Name": "Banana Muffin",
            "category": "Amazing Muffins",
            "dec": "Delicious muffin flavored with fresh banana.",
            "KES": 300,
            "RectImageURL":bananaMuffinRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": chocolateChipMuffin,
            "Name": "Chocolate Chip Muffin",
            "category": "Amazing Muffins",
            "dec": "Delicious muffin flavored with chocolate drops.",
            "KES": 300,
            "RectImageURL":chocolateChipMuffinRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": vanillaMuffin,
            "Name": "Vanilla Muffin",
            "category": "Amazing Muffins",
            "dec": "Delicious muffin flavored with vanilla.",
            "KES": 300,
            "RectImageURL":vanillaMuffinRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": chocolateMuffin,
            "Name": "Chocolate Muffin",
            "category": "Amazing Muffins",
            "dec": "Decadent chocolate muffins that are perfect for chocolate lovers.",
            "KES": 300,
            "RectImageURL":chocolateMuffinrect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": plainCroissand,
            "Name": "Plain Croissant",
            "category": "Pastries",
            "dec": "A flaky plain croissant with a combination of butter, egg, sugar, milk & flour.",
            "KES": 310,
            "RectImageURL":plainCroissandRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": almondCroissant,
            "Name": "Almond Croissant",
            "category": "Pastries",
            "dec": "A flaky plain croissant with a combination of butter, egg, sugar, milk & flour flavored with almonds.",
            "KES": 350,
            "RectImageURL":almondCroissantRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": chocolateTwist,
            "Name": "Chocolate Twist",
            "category": "Pastries",
            "dec": "A creamy twisted flaky pastry with a combination of Butter, Egg, Sugar, milk & flour infused with chocolate.",
            "KES": 320,
            "RectImageURL":chocolateTwistRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": CinnamonCroissant,
            "Name": "Cinnamon Croissant",
            "category": "Pastries",
            "dec": "A creamy rolled flaky pastry with raisins & cinnamon's.",
            "KES": 310,
            "RectImageURL":CinnamonCroissantRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": FruitSalad,
            "Name": "Fruit Salad",
            "category": "Fruitful Delights",
            "dec": "Pineapples, Watermelon, sweetmelon, Mango, Banana and Paw Paw unite in this juicy, delicious fruit salad cut into dices",
            "KES": 700,
            "RectImageURL":FruitSaladRect,
            "Upgrades":[
                { name: "Add Honey", price: 150 },
                { name: "Add Nuts", price: 150 },
                { name: "Add Yogurt", price: 150 }
            ]
        },

        {
            "ImageURL": HotFudgeSundae,
            "Name": "Hot Fudge Sundae",
            "category":"Amazing Sundaes",
            "dec": "Three scoops of your choice of premium ice cream, topped with chocolate fudge sauce and caramel sauce nuts and raisins.",
            "KES": 610,
            "RectImageURL":HotFudgeSundaeRect,
            "Upgrades":[
                { name: "Caramel Sauce or Chocochip/ Strawberry Syrup", price: 100 },
                { name: "Whipped Cream", price: 100 },
                { name: "Nuts • Raisins", price: 150 }
            ]
        },
        {
            "ImageURL": ChocolateBrownieSundae,
            "Name": "Chocolate Brownie Sundae",
            "category":"Amazing Sundaes",
            "dec": "Three scoops of your choice of premium ice cream, topped with chocolate sauce, caramel sauce, nuts, raisins. Served with warm freshly baked chocolate brownie.",
            "KES": 650,
            "RectImageURL":ChocolateBrownieSundaeReact,
            "Upgrades":[
                { name: "Caramel Sauce or Chocochip/ Strawberry Syrup", price: 100 },
                { name: "Whipped Cream", price: 100 },
                { name: "Nuts • Raisins", price: 150 }
            ]
        },
        {
            "ImageURL": IceCreamCookieSandwich,
            "Name": "Ice Cream Cookie Sandwich",
            "category":"Amazing Sundaes",
            "dec": "Three scoops of your choice of premium ice cream, topped with chocolate sauce, caramel sauce, nuts and raisins. Served with our fresh homemade chocolate chip cookies.",
            "KES": 650,
            "RectImageURL":IceCreamCookieSandwichRect,
            "Upgrades":[
                { name: "Caramel Sauce or Chocochip/ Strawberry Syrup", price: 100 },
                { name: "Whipped Cream", price: 100 },
                { name: "Nuts • Raisins", price: 150 }
            ]
        },
        {
            "ImageURL": IceCreamSundae,
            "Name": "Ice Cream Sundae",
            "category":"Amazing Sundaes",
            "dec": "Three generous scoops of your choice of premium ice cream, topped with strawberry syrup, nuts and fresh strawberries.",
            "KES": 570,
            "RectImageURL":IceCreamSundaeRect,
            "Upgrades":[
                { name: "Caramel Sauce or Chocochip/ Strawberry Syrup", price: 100 },
                { name: "Whipped Cream", price: 100 },
                { name: "Nuts • Raisins", price: 150 }
            ]
        },
        {
            "ImageURL": BananaSplitSundae,
            "Name": "Banana Split Sundae",
            "category":"Amazing Sundaes",
            "dec": "Fresh banana and three generous scoops of premium ice cream with caramel, chocolate sauce, whipped cream & chopped nuts.",
            "KES": 650,
            "RectImageURL":BananaSplitSundaeRect,
            "Upgrades":[
                { name: "Caramel Sauce or Chocochip/ Strawberry Syrup", price: 100 },
                { name: "Whipped Cream", price: 100 },
                { name: "Nuts • Raisins", price: 150 }
            ]
        },
        {
            "ImageURL": FudgeObsession,
            "Name": "Fudge Obsession",
            "category": "A La Mode",
            "dec": "Rich fresh creamy chocolate cake topped with a premium scoop of vanilla ice cream and hot chocolate sauce.",
            "KES": 580,
            "RectImageURL":FudgeObsessionRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": Brownieindulgence,
            "Name": "Brownie Indulgence",
            "category": "A La Mode",
            "dec": "Rich square moist chocolate cake topped with a premium scoop of vanilla ice cream and chocolate sauce.",
            "KES": 580,
            "RectImageURL":BrownieindulgenceRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": applePieBlonde,
            "Name": "Apple Pie Blonde",
            "category": "A La Mode",
            "dec": "Tender apples in a light, flaky crust topped with premium vanilla ice cream & caramel sauce. Served hot or cold.",
            "KES": 580,
            "RectImageURL":applePieBlondeRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": sliceALaMode,
            "Name": "Slice A La Mode",
            "category": "A La Mode",
            "dec": "Choice of rich, warm Marble / Banana / Frosted lemon cake topped with premium vanilla ice cream.",
            "KES": 580,
            "RectImageURL":sliceALaModeRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": vanillaScoop,
            "Name": "Vanilla Scoop",
            "category": "Premium Ice Creams",
            "dec": "Scoop of premium vanilla ice cream.",
            "KES": 340,
            "RectImageURL":vanillaScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": strawberryScoop,
            "Name": "Strawberry Scoop",
            "category": "Premium Ice Creams",
            "dec": "Scoop of premium strawberry ice cream.",
            "KES": 340,
            "RectImageURL":strawberryScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": chocolateScoop,
            "Name": "Chocolate Scoop",
            "category": "Premium Ice Creams",
            "dec": "Scoop of premium chocolate ice cream.",
            "KES": 340,
            "RectImageURL":chocolateScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": bananaScoop,
            "Name": "Banana Scoop",
            "category": "Premium Ice Creams",
            "dec": "Scoop of premium banana ice cream.",
            "KES": 340,
            "RectImageURL":bananaScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": mintScoop,
            "Name": "Mint Scoop",
            "category": "Premium Ice Creams",
            "dec": "Scoop of premium mint ice cream.",
            "KES": 340,
            "RectImageURL":mintScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": mangoScoop,
            "Name": "Mango Scoop",
            "category": "Premium Ice Creams",
            "dec": "Scoop of premium mango ice cream.",
            "KES": 340,
            "RectImageURL":mangoScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": coffeeScoop,
            "Name": "Coffee Scoop",
            "category": "Premium Ice Creams",
            "dec": "Scoop of premium coffee ice cream.",
            "KES": 340,
            "RectImageURL":coffeeScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": coconutScoop,
            "Name": "Coconut Scoop",
            "category": "Premium Ice Creams",
            "dec": "Scoop of premium coconut ice cream.",
            "KES": 340,
            "RectImageURL":coconutScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": doubleScoop,
            "Name": "Double Scoop",
            "category": "Premium Ice Creams",
            "dec": "Two scoops of premium ice creams - flavours of your choice.",
            "KES": 440,
            "RectImageURL":doubleScoopRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": SaltedCaramel,
            "Name": "Salted Caramel Cake",
            "category": "Cakes",
            "dec": "Homemade caramel sauce in the cake layer, frosting and the drip.",
            "KES": 530,
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.8 KG",
                    Price:4240
                },
                {
                    Quantity:"3 KG",
                    Price:6800

                }
            ],
            "RectImageURL":SaltedCaramelRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": blackForestSlice,
            "Name": "Black Forest Slice",
            "category": "Cakes",
            "dec": "Delicious chocolate sponge cake with fresh cream, cherries topped with choco flakes.",
            "KES": 510,
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.5 KG",
                    Price:2800
                },
                {
                    Quantity:"3 KG",
                    Price:5100

                }
            ],
            "RectImageURL":blackForestSliceRect,
            "Upgrades":[
            ]
        },
        {
            "ImageURL": applePie,
            "Name": "Apple Pie Slice",
            "category": "Cakes",
            "dec": "Apple pie cake slice.",
            "KES": 420,
            "RectImageURL":applePieRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
               
            ]
        },
        {
            "ImageURL": chocolateFudgeSlice,
            "Name": "Chocolate Fudge Slice",
            "category": "Cakes",
            "dec": "Rich fresh creamy chocolate cake filled with premium chocolate.",
            "KES": 510,
            "RectImageURL":chocolateFudgeSliceRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.5 KG",
                    Price:2800
                },
                {
                    Quantity:"3 KG",
                    Price:5100

                }
            ]
        },
        {
            "ImageURL": redVelvetSlice,
            "Name": "Red Velvet Slice",
            "category": "Cakes",
            "dec": "Fresh creamy Red velvet cake topped with mascarpone.",
            "KES": 550,
            "RectImageURL":redVelvetSliceRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.8 KG",
                    Price:4400
                },
                {
                    Quantity:"3 KG",
                    Price:6800

                }
            ]
        },
        {
            "ImageURL": creamyCarrotSlice,
            "Name": "Creamy Carrot Slice",
            "category": "Cakes",
            "dec": "Fresh carrot cake infused with butter, cream & cheese.",
            "KES": 510,
            "RectImageURL":creamyCarrotSliceRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.8 KG",
                    Price:4080
                },
                {
                    Quantity:"3 KG",
                    Price:6800

                }
            ]
        },
        {
            "ImageURL":whiteForest,
            "Name": "White Forest Slice",
            "category": "Cakes",
            "dec": "Moist White Forest cake filled with strawberries and cheese frosting.",
            "KES": 510,
            "RectImageURL":whiteForestRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.5 KG",
                    Price:2800
                },
                {
                    Quantity:"3 KG",
                    Price:5100

                }
            ]
        },
        {
            "ImageURL": marbleCakeSlice,
            "Name": "Marble Cake Slice",
            "category": "Cakes",
            "dec": "Moist sponge vanilla cake with light chocolate.",
            "KES": 350,
            "RectImageURL":marbleCakeSliceRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.5 KG",
                    Price:3150
                },
                {
                    Quantity:"3 KG",
                    Price:5010

                }
            ]
        },
        {
            "ImageURL": lemonCakeSlice,
            "Name": "Lemon Cake Slice",
            "category": "Cakes",
            "dec": "Soft sponge vanilla cake with lemon flavor & frosted lemon icing.",
            "KES": 350,
            "RectImageURL":lemonCakeSliceRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.5 KG",
                    Price:3150
                },
                {
                    Quantity:"3 KG",
                    Price:5010

                }
            ]
        },
        {
            "ImageURL": BananaCakeSlice,
            "Name": "Banana Cake Slice",
            "category": "Cakes",
            "dec": "Moist soft cake slice made with fresh bananas.",
            "KES": 350,
            "RectImageURL":BananaCakeSliceRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
                {
                    Quantity:"1.5 KG",
                    Price:3150
                },
                {
                    Quantity:"3 KG",
                    Price:5010

                }
            ]
        },
        {
            "ImageURL": chocolateBrownie,
            "Name": "Chocolate Brownie",
            "category": "Cakes",
            "dec": "Rich square moist chocolate cake.",
            "KES": 420,
            "RectImageURL":chocolateBrownieRect,
            "Upgrades":[
            ],
            "type":"Slice",
            "Quantity":[
               
            ]
        },
        {
            "ImageURL": gingerCookiesRect,
            "Name": "Ginger Cookie",
            "category": "Cookies",
            "dec": "10 pcs ginger cookie in a jar.",
            "KES": 250,
            "RectImageURL":gingerCookiesRect,
            "Upgrades":[
            ]
        }
        
    ]
    
}
export default DecadentDessert